// 市场信息
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>

        <div style="
        width:43.875rem;
        margin-left: auto;
        margin-top:4rem;
        margin-right: auto;">
            <img class="img" :src="url">
        </div>
        <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Market',
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
  },
  data () {
    return {
      image: '',
      url: 'http://quote.cfi.cn/DrawPrice.aspx?stockid=34589&type=day&w=540&h=400&round=0603160248007',
    }
  },
  components: {
    // Header
    Tabbar,
    Logo,
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.img {
  margin-left: auto;
  margin-right: auto;
  display: table-cell;
  width: 40.875rem;
  height: 29.375rem;
}
</style>